import React from 'react'
import { useGetChangeLogsByEntityIdQuery } from '~graphql/generated/graphql'
import SharedStack from '../wrappers/shared-stack'
import ChangeLogListItem from './change-log-list-item'
import SharedHeader from '../texts/shared-header'
import MissingText from '../texts/missing-text'
import { useChangeLogEntities } from './use-change-log-entities'
import CenteredSpinner from '../centered-spinner'

interface Props {
    entityId: string
}

export default function ChangeLogView({ entityId }: Props) {
    const { data, loading, error } = useGetChangeLogsByEntityIdQuery({
        variables: {
            entityId,
        },
    })

    const changeLogsEntries = data?.getChangeLogsByEntityId || []
    const changeLogEntities = useChangeLogEntities(changeLogsEntries)

    if (loading) {
        return <CenteredSpinner />
    }

    if (error) {
        return (
            <SharedStack>
                <SharedHeader mb={6}>Change Log</SharedHeader>
                <MissingText>Failed to load change logs</MissingText>
            </SharedStack>
        )
    }

    return (
        <SharedStack>
            <SharedHeader mb={6}>Change Log</SharedHeader>
            <SharedStack spacing={6}>
                {changeLogsEntries.map(changeLog => (
                    <ChangeLogListItem
                        key={changeLog.id}
                        changeLog={changeLog}
                        changeLogEntities={changeLogEntities}
                    />
                ))}
                {changeLogsEntries.length === 0 && (
                    <MissingText>No change logs found</MissingText>
                )}
            </SharedStack>
        </SharedStack>
    )
}
